export enum PenTeam {
  Home = 'home',
  Away = 'away'
}
